import { useStores } from '@littlebird/sdk';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { observer } from 'mobx-react-lite';
import { useCallback } from 'react';
import { z } from 'zod';

import { useActionCardPrefill } from '@/features/action-cards/use-action-card-prefill';
import { NewChat } from '@/features/chat/chat-new';
import { getTabDraftId } from '@/features/chat/draft-ids';
import { tabStore } from '@/features/tabs/tabs.store';
import { NEW_CHAT_ID } from '@/utils/constants';

const RouteComponent = observer(() => {
  const search = Route.useSearch();
  const navigate = useNavigate();
  const { drafts, actionCards } = useStores();
  const tabId = tabStore.activeTabId;

  useActionCardPrefill({
    search,
    draftId: tabId ? getTabDraftId(tabId) : NEW_CHAT_ID,
    actionCards,
    drafts,
    clearSearch: useCallback(
      () => void navigate({ to: '/chats', search: {}, replace: true }),
      [navigate]
    ),
  });

  return <NewChat />;
});

export const Route = createFileRoute('/_authenticated/chats/')({
  component: RouteComponent,
  staticData: { paneSurface: 'translucent', headerOverlay: true },
  validateSearch: z.object({
    auto_prompt: z.string().optional().catch(undefined),
    source_action_card: z.string().uuid().optional().catch(undefined),
    new: z.boolean().optional().catch(undefined),
  }).parse,
});
